import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

import { getEnvironment } from '@sunrun/sales-experience-shared';

// Access the Firebase app instance.
// Firebase auth and rules prevents access to the database without a valid token:
// https://firebase.google.com/docs/rules/rules-and-auth
const firebaseConfigStaging = {
  apiKey: 'AIzaSyByurx7ATo2VMofeZ3JnnIy1qJD18pBdAc',
  authDomain: 'fir-chat-poc-17ac7.firebaseapp.com',
  databaseURL: 'https://fir-chat-poc-17ac7-default-rtdb.firebaseio.com',
  projectId: 'fir-chat-poc-17ac7',
  storageBucket: 'fir-chat-poc-17ac7.firebasestorage.app',
  messagingSenderId: '429696132037',
  appId: '1:429696132037:web:6ab2d9f0835ade10ac21ac',
};

const firebaseConfigProduction = {
  apiKey: 'AIzaSyBy-ef9kIxC4omSHrz6p7IvMCnuku8dAZA',
  authDomain: 'sr-sales-chat-center-prod.firebaseapp.com',
  databaseURL: 'https://sr-sales-chat-center-prod-default-rtdb.firebaseio.com',
  projectId: 'sr-sales-chat-center-prod',
  storageBucket: 'sr-sales-chat-center-prod.firebasestorage.app',
  messagingSenderId: '84219997400',
  appId: '1:84219997400:web:87cc0afa4082de8a65fbad',
  measurementId: 'G-918JSHWH01',
};

// Initialize Firebase
const firebaseApp = initializeApp(
  getEnvironment() === 'production'
    ? firebaseConfigProduction
    : firebaseConfigStaging,
);

// Initialize Firestore and get a reference to the service
const firebaseDb = getFirestore(firebaseApp, '(default)');

// Initialize Functions
const firebaseFunctions = getFunctions(firebaseApp);

const firebaseAuth = getAuth(firebaseApp);

export { firebaseDb, firebaseFunctions, firebaseAuth };
